import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d42cb4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "main-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "THE FIELDS MARKED WITH (*) ARE REQUIRED.", -1))
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "first-name" }, "FIRST NAME*", -1))
const _hoisted_5 = { class: "input-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "last-name" }, "LAST NAME*", -1))
const _hoisted_7 = { class: "country-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Artist Origin/Nationality", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "region" }, "REGION*", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select Region", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "COUNTRY*", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select Country", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "image-container" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "about" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ABOUT", -1))
const _hoisted_21 = { class: "exhibitions" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "SELECTED EXHIBITIONS", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Location"),
    /*#__PURE__*/_createElementVNode("th", null, "Country"),
    /*#__PURE__*/_createElementVNode("th", null, "City"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "solo_exhibition" }, "Solo", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "group_exhibition" }, "Group", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "collections" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "ARTICLES", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Adding an article mentioning the artist is beneficial for both the artist and the collectors. ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Url"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "collections" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "KEY COLLECTIONS", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Museum"),
    /*#__PURE__*/_createElementVNode("th", null, "Country"),
    /*#__PURE__*/_createElementVNode("th", null, "City"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "website" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "WEBSITE", -1))
const _hoisted_41 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_SpinnerLoader, { key: 0 }))
        : (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "first-name",
                  id: "first-name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "last-name",
                  id: "last-name",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.lastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.region) = $event))
                  }, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (regionItem) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: regionItem.id,
                        value: regionItem.name
                      }, _toDisplayString(_ctx.getRegionName(+regionItem.id)), 9, _hoisted_11))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.region]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.country) = $event)),
                    disabled: _ctx.filteredCountries.length === 0
                  }, [
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountries, (countryItem) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: countryItem.id,
                        value: countryItem.name
                      }, _toDisplayString(_ctx.getCountryName(+countryItem.id)), 9, _hoisted_15))
                    }), 128))
                  ], 8, _hoisted_13), [
                    [_vModelSelect, _ctx.country]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.imageUrl
                    }, null, 8, _hoisted_17))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: require('@/assets/imgs/avatar.png')
                    }, null, 8, _hoisted_18)),
                _createElementVNode("label", null, [
                  _createTextVNode(" UPLOAD IMAGE "),
                  _createElementVNode("input", {
                    id: "image-upload",
                    type: "file",
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                    style: {"display":"none"}
                  }, null, 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_QuillEditor, {
                  theme: "snow",
                  toolbar: "full",
                  contentType: "html",
                  content: _ctx.about,
                  "onUpdate:content": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.about) = $event)),
                  placeholder: "About...",
                  style: {"height":"300px","width":"100%"}
                }, null, 8, ["content"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("table", null, [
                  _hoisted_23,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exhibitions, (exhibition) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: exhibition.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(exhibition.title), 1),
                        _createElementVNode("td", null, _toDisplayString(exhibition.date), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatExhibitionType(exhibition.exhibition_type)), 1),
                        _createElementVNode("td", null, _toDisplayString(exhibition.location), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getCountryName(exhibition.country_id)), 1),
                        _createElementVNode("td", null, _toDisplayString(exhibition.city), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.removeExhibition(exhibition.title))
                          }, [
                            _createVNode(_component_v_icon, { icon: "mdi-delete" })
                          ], 8, _hoisted_24)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Title",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.exhibitionTitle) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.exhibitionTitle]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.exhibitionsDate) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.exhibitionsDate]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.exhibitionsType) = $event))
                        }, _hoisted_27, 512), [
                          [_vModelSelect, _ctx.exhibitionsType]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.exhibitionsLocation) = $event)),
                          placeholder: "Location"
                        }, null, 512), [
                          [_vModelText, _ctx.exhibitionsLocation]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.exhibitionCountry) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: country.id,
                              value: country.id
                            }, _toDisplayString(country.name), 9, _hoisted_28))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.exhibitionCountry]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.exhibitionCity) = $event)),
                          placeholder: "City"
                        }, null, 512), [
                          [_vModelText, _ctx.exhibitionCity]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.addExhibition && _ctx.addExhibition(...args)))
                        }, [
                          _createVNode(_component_v_icon, { icon: "mdi-plus" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _hoisted_31,
                _createElementVNode("table", null, [
                  _hoisted_32,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: article.url
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("p", null, _toDisplayString(article.title), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("p", null, _toDisplayString(article.url), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.removeArticle(article.url))
                          }, [
                            _createVNode(_component_v_icon, { icon: "mdi-delete" })
                          ], 8, _hoisted_33)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Title",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.title) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.title]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "URL",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.url) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.url]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addArticle && _ctx.addArticle(...args)))
                        }, [
                          _createVNode(_component_v_icon, { icon: "mdi-plus" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("table", null, [
                  _hoisted_36,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.key_collections, (collection) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: collection.date
                      }, [
                        _createElementVNode("td", null, _toDisplayString(collection.date), 1),
                        _createElementVNode("td", null, _toDisplayString(collection.museum_name), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getCountryName(collection.country_id)), 1),
                        _createElementVNode("td", null, _toDisplayString(collection.city), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.removeCollection(collection.museum_name))
                          }, [
                            _createVNode(_component_v_icon, { icon: "mdi-delete" })
                          ], 8, _hoisted_37)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.collectionsDate) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.collectionsDate]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Museum",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.collectionsMuseum) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.collectionsMuseum]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.collectionsCountry) = $event)),
                          class: "country-select"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: country.id,
                              value: country.id
                            }, _toDisplayString(country.name), 9, _hoisted_38))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.collectionsCountry]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "City",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.collectionsCity) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.collectionsCity]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addCollection && _ctx.addCollection(...args)))
                        }, [
                          _createVNode(_component_v_icon, { icon: "mdi-plus" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "website",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.website) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.website]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$router.back()))
              }, "BACK"),
              (_ctx.id || _ctx.role === 'artist')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.updateArtistData && _ctx.updateArtistData(...args)))
                  }, " UPDATE "))
                : _createCommentVNode("", true),
              ((_ctx.role === 'gallery' || _ctx.isPrivateSeller) && !_ctx.id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.updateArtistData && _ctx.updateArtistData(...args)))
                  }, " ADD "))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}